'use client';

import Footer from '@/components/home/Footer';
import Header from '@/components/home/Header';
import { ContentWrapper } from '@/styles/common';
import { useRouter, redirect } from 'next/navigation';
import { useEffect } from 'react';
import styled from 'styled-components';

const Home = () => {
  const router = useRouter();
  useEffect(() => {
    redirect('/login');
  }, []);

  return;
  
  return (
    <Container>
      <ContentWrapper>
        <Header />
        <MainContent>
          <LargeText>단, 0일</LargeText>
          <SubTitle>오늘자 영업일 기준 온라인 법정의무교육 신청 가능 기간</SubTitle>
          <Description>AI가 60초면 필요한 법정의무교육을 진단해드려요</Description>
          <EventButtonWrapper onClick={() => router.push('question')}>
            <EventLabel>EVENT!</EventLabel>
            <ActionButton>지금 바로 AI 진단 서비스 받으러 가기</ActionButton>
          </EventButtonWrapper>
        </MainContent>
        <Footer />
      </ContentWrapper>
    </Container>
  );
};

export default Home;

const Container = styled.div`
  background-color: #f8f9fc;
`;

const MainContent = styled.div`
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  flex-grow: 1;
`;

const LargeText = styled.div`
  font-size: 120px;
  font-weight: 1000;
  margin-bottom: 20px;
  color: #333333;
`;

const SubTitle = styled.div`
  font-size: 20px;
  font-weight: bold;
  margin-bottom: 10px;
`;

const Description = styled.div`
  color: #666666;
  margin-bottom: 70px;
  font-size: 16px;
`;

const EventButtonWrapper = styled.div`
  background-color: #007bff;
  color: white;
  padding: 15px 30px;
  border-radius: 99px;
  position: relative;
  display: flex;
  align-items: center;
  cursor: pointer;
`;

const EventLabel = styled.div`
  background-color: #ff0000;
  color: white;
  padding: 5px 10px;
  font-size: 12px;
  border-radius: 20px;
  font-weight: bold;
  position: absolute;
  top: -10px;
  right: -10px;
`;

const ActionButton = styled.div`
  font-size: 16px;
`;
